import createStoreModule from "shared/lib/createStoreModule.js";
import sortable from "shared/lib/sortable.js";
export default createStoreModule("cardType");
